import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';


@Injectable()
export class ChartsService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getDataTongHopMuaHang(queryParams: QueryParamsModel): Observable<QueryResultsModel> {		
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(environment.ApiRoot + '/tonghopmuahang/TongHopMuaHangTheoHH_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getDataTongHopMuaHangNCC(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		
		const httpHeaders = this.httpUtils.getHTTPHeaders();

		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(environment.ApiRoot + '/tonghopmuahang/TongHopMuaHangTheoNCC_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	//TonKhoHienTai_List
	getTonKhoHienTai(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		//TongHopTonKho_List
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(environment.ApiRoot + '/kho/TonKhoHienTai_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	TheoDoiKhoiLuongNhapKho(tungay, denngay): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("tungay", tungay).set("denngay", denngay)
		const url =  environment.ApiRoot + '/dashboard' + '/TheoDoiKhoiLuongNhapKho' ;
		return this.http.get<any>(url , { headers: httpHeaders, params: params });
	}
	TheoDoiKhoiLuongXuatKho(tungay, denngay): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("tungay", tungay).set("denngay", denngay)
		const url =  environment.ApiRoot + '/dashboard' + '/TheoDoiKhoiLuongXuatKho' ;
		return this.http.get<any>(url , { headers: httpHeaders, params: params });
	}
	KetQuaSanXuat(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/dashboard' + '/KetQuaSanXuat' ;
		return this.http.get<any>(url , { headers: httpHeaders});
	}
	getTongHopTonKho(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		//TongHopTonKho_List
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(environment.ApiRoot + '/tonghoptonkho/TongHopTonKho_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	listKho() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/Kho_List' ;
		return this.http.get<any>(url , { headers: httpHeaders });
	}
}
